import { render } from "./MusicPlayerCard.vue?vue&type=template&id=2229ead0&scoped=true"
import script from "./MusicPlayerCard.vue?vue&type=script&lang=js"
export * from "./MusicPlayerCard.vue?vue&type=script&lang=js"

import "./MusicPlayerCard.vue?vue&type=style&index=0&id=2229ead0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2229ead0"]])

export default __exports__